export var ProductType;
(function (ProductType) {
    ProductType["PACKAGE"] = "PACKAGE";
    ProductType["HOTEL"] = "HOTEL";
    ProductType["FLIGHT"] = "FLIGHT";
    ProductType["RAIL_PACKAGE"] = "RAIL_PACKAGE";
})(ProductType || (ProductType = {}));
